<div *ngIf="heeftOverigeInkomsten()">

    <form [formGroup]="specRapportFormGroup">
        <div class="row">
            <div formGroupName="specificatieROW">
                <div formGroupName="opbouw">
                    <div *ngIf="heeftRow()">
                        <div class="left">
                            <div class="row">
                                <div class="col col-1">
                                    Inkomsten uit overige werkzaamheden
                                </div>
                                <div class="col-2">
                                    <snelstart-ui-number-form-control
                                            [decimals]="0"
                                            align="right"
                                            class="me-1 custom-input-150"
                                            formControlName="inkomstenUitOVerigeWerkzaamheden"
                                            id="inkomstenUitOVerigeWerkzaamheden"
                                            prefix="€"
                                            placeholder="0"
                                    ></snelstart-ui-number-form-control>
                                </div>
                                <div class="col-3"></div>
                                <div class="col-4"></div>
                            </div>
                        </div>
                        <div class="left">
                            <div class="row">
                                <div class="col col-1">
                                    Af: Kosten overige werkzaamheden
                                </div>
                                <div class="col-2">
                                    <snelstart-ui-number-form-control
                                            [decimals]="0"
                                            align="right"
                                            class="me-1 custom-input-150"
                                            formControlName="kostenTerZakeVanOverigeWerkzaamheden"
                                            id="kostenTerZakeVanOverigeWerkzaamheden"
                                            placeholder="0"
                                            prefix="€ -"
                                    ></snelstart-ui-number-form-control>
                                </div>
                                <div class="col-3"></div>
                                <div class="col-4"></div>
                            </div>
                        </div>
                        <div class="left">
                            <div class="row">
                                <div class="col col-1">
                                    <div *ngIf="!partnerBoolean">
                                        <b>Saldo overige werkzaamheden {{ this.dataService.naamAangever }}</b>
                                    </div>
                                    <div *ngIf="partnerBoolean">
                                        <b>Saldo overige werkzaamheden {{ this.dataService.naamPartner }}</b>
                                    </div>
                                </div>
                                <div class="col-2"></div>
                                <div class="col-3">
                                    <snelstart-ui-number-form-control
                                            [decimals]="0"
                                            align="right"
                                            class="me-1 custom-input-150"
                                            formControlName="saldoRow"
                                            id="saldoRow"
                                            prefix="€"
                                    ></snelstart-ui-number-form-control>
                                </div>
                                <div class="col-4"></div>
                            </div>
                        </div>
                        <div class="space20"></div>
                    </div>

                    <div *ngIf="heeftTbs()">
                        <div class="left">
                            <div class="row">
                                <div class="col col-1">
                                    Inkomsten uit terbeschikkingstelling
                                </div>
                                <div class="col-2">
                                    <snelstart-ui-number-form-control
                                            [decimals]="0"
                                            align="right"
                                            class="me-1 custom-input-150"
                                            formControlName="inkomstenUitTBS"
                                            id="inkomstenUitTBS"
                                            prefix="€"
                                            placeholder="0"
                                    ></snelstart-ui-number-form-control>
                                </div>
                                <div class="col-3"></div>
                                <div class="col-4"></div>
                            </div>
                        </div>
                        <div *ngIf="specRapportFormGroup.get('specificatieROW.opbouw.kostenTerZakeVanTBS')?.value > 0"
                             class="left">
                            <div class="row">
                                <div class="col col-1">
                                    Af: Kosten terbeschikkingstelling
                                </div>
                                <div class="col-2">
                                    <snelstart-ui-number-form-control
                                            [decimals]="0"
                                            align="right"
                                            class="me-1 custom-input-150"
                                            formControlName="kostenTerZakeVanTBS"
                                            id="kostenTerZakeVanTBS"
                                            placeholder="0"
                                            prefix="€ -"
                                    ></snelstart-ui-number-form-control>
                                </div>
                                <div class="col-3"></div>
                                <div class="col-4"></div>
                            </div>
                        </div>
                        <div class="left">
                            <div class="row">
                                <div class="col col-1">
                                    Af: Terbeschikkingsstellingsvrijstelling
                                </div>
                                <div class="col-2">
                                    <snelstart-ui-number-form-control
                                            [decimals]="0"
                                            align="right"
                                            class="me-1 custom-input-150"
                                            formControlName="tbsVrijstelling"
                                            id="tbsVrijstelling"
                                            prefix="€ -"
                                    ></snelstart-ui-number-form-control>
                                </div>
                                <div class="col-3"></div>
                                <div class="col-4"></div>
                            </div>
                        </div>
                        <div class="left">
                            <div class="row">
                                <div class="col col-1">
                                    <div *ngIf="!partnerBoolean">
                                        <b> Saldo
                                            terbeschikkingstellingsregeling {{ this.dataService.naamAangever }}</b>
                                    </div>
                                    <div *ngIf="partnerBoolean">
                                        <b> Saldo terbeschikkingstellingsregeling {{ this.dataService.naamPartner }}</b>
                                    </div>
                                </div>
                                <div class="col-2"></div>
                                <div class="col-3">
                                    <snelstart-ui-number-form-control
                                            [decimals]="0"
                                            align="right"
                                            class="me-1 custom-input-150"
                                            formControlName="saldoTbs"
                                            id="saldoTbs"
                                            prefix="€"
                                    ></snelstart-ui-number-form-control>
                                </div>
                                <div class="col-4"></div>
                            </div>
                        </div>
                        <div class="space20"></div>
                    </div>
                </div>
            </div>

            <div formGroupName="specificatiePU">
                <div formGroupName="opbouw">
                    <div *ngIf="heeftAlimentatie()">
                        <div class="left">
                            <div class="row">
                                <div class="col col-1">
                                    Ontvangen alimentatie
                                </div>
                                <div class="col-2">
                                    <snelstart-ui-number-form-control
                                            [decimals]="0"
                                            align="right"
                                            class="me-1 custom-input-150"
                                            formControlName="ontvangenAlimentatie"
                                            id="ontvangenAlimentatie"
                                            prefix="€"
                                    ></snelstart-ui-number-form-control>
                                </div>
                                <div class="col-3"></div>
                                <div class="col-4"></div>
                            </div>
                        </div>
                        <div class="left">
                            <div class="row">
                                <div class="col col-1">
                                    Af: Kosten ontvangen alimentatie
                                </div>
                                <div class="col-2">
                                    <snelstart-ui-number-form-control
                                            [decimals]="0"
                                            align="right"
                                            class="me-1 custom-input-150"
                                            formControlName="kostenAlimentatie"
                                            id="kostenAlimentatie"
                                            placeholder="0"
                                            prefix="€ -"
                                    ></snelstart-ui-number-form-control>
                                </div>
                                <div class="col-3"></div>
                                <div class="col-4"></div>
                            </div>
                        </div>
                        <div class="left">
                            <div class="row">
                                <div class="col col-1">
                                    <div *ngIf="!partnerBoolean">
                                        <b>Saldo alimentatie {{ this.dataService.naamAangever }}</b>
                                    </div>
                                    <div *ngIf="partnerBoolean">
                                        <b>Saldo alimentatie {{ this.dataService.naamPartner }}</b>
                                    </div>
                                </div>
                                <div class="col-2"></div>
                                <div class="col-3">
                                    <snelstart-ui-number-form-control
                                            [decimals]="0"
                                            align="right"
                                            class="me-1 custom-input-150"
                                            formControlName="saldoAlimentatie"
                                            id="saldoAlimentatie"
                                            prefix="€"
                                    ></snelstart-ui-number-form-control>
                                </div>
                                <div class="col-4"></div>
                            </div>
                        </div>

                        <div class="space20"></div>
                    </div>

                    <div *ngIf="heeftPerUitkeringen()">
                        <div class="left">
                            <div class="row">
                                <div class="col col-1">
                                    Ontvangen periodieke uitkeringen
                                </div>
                                <div class="col-2">
                                    <snelstart-ui-number-form-control
                                            [decimals]="0"
                                            align="right"
                                            class="me-1 custom-input-150"
                                            formControlName="ontvangenPeriodiekeUitkeringen"
                                            id="ontvangenPeriodiekeUitkeringen"
                                            prefix="€"
                                    ></snelstart-ui-number-form-control>
                                </div>
                                <div class="col-3"></div>
                                <div class="col-4"></div>
                            </div>
                        </div>
                        <div class="left">
                            <div class="row">
                                <div class="col col-1">
                                    Af: Kosten periodieke uitkeringen
                                </div>
                                <div class="col-2">
                                    <snelstart-ui-number-form-control
                                            [decimals]="0"
                                            align="right"
                                            class="me-1 custom-input-150"
                                            formControlName="kostenPeriodiekeUitkeringen"
                                            id="kostenPeriodiekeUitkeringen"
                                            placeholder="0"
                                            prefix="€ -"
                                    ></snelstart-ui-number-form-control>
                                </div>
                                <div class="col-3"></div>
                                <div class="col-4"></div>
                            </div>
                        </div>
                        <div class="left">
                            <div class="row">
                                <div class="col col-1">
                                    <div *ngIf="!partnerBoolean">
                                        <b>Saldo periodieke uitkeringen {{ this.dataService.naamAangever }}</b>
                                    </div>
                                    <div *ngIf="partnerBoolean">
                                        <b> Saldo periodieke uitkeringen {{ this.dataService.naamPartner }}</b>
                                    </div>
                                </div>
                                <div class="col-2"></div>
                                <div class="col-3">
                                    <snelstart-ui-number-form-control
                                            [decimals]="0"
                                            align="right"
                                            class="me-1 custom-input-150"
                                            formControlName="saldoPerUitkeringen"
                                            id="saldoPerUitkeringen"
                                            prefix="€"
                                    ></snelstart-ui-number-form-control>
                                </div>
                                <div class="col-4"></div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </form>
    <div class="space20"></div>


</div>


<div *ngIf="!heeftOverigeInkomsten()" class="pt-3" style="width: 75%">
    <snelstart-ui-alert type="info">
        <div *ngIf="!partnerBoolean">
            Er zijn geen overige inkomsten voor {{ dataService.naamAangever }} ingevuld.
        </div>

        <div *ngIf="partnerBoolean">
            Er zijn geen overige inkomsten voor {{ dataService.naamPartner }} ingevuld.
        </div>
    </snelstart-ui-alert>
</div>
